$(document).ready(function() {
	$("#emailForm").validate();
	$("#gsm").mask("(999) 999-9999");
	
	$("#gsmCode").intlTelInput({
		preferredCountries: ['TR'],
		americaMode: false
	});
	
	$('#invitefail').hide();
	
	$('#invite-tabs').tabs();

	$('.facebook-send').click(function(){
        FB.ui({ 
            method: 'send', link: link,
        }, function(response) { });
    });
});

function inviteUsers() {
	var emails = $("#emails").val();
	var isEmailValid = emailValidation('emails');
	if(grecaptcha.getResponse().length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}
	if (!isEmailValid) {
		grecaptcha.reset();
		return false;
	}	
	if (emails == "") {
		alert(FmtMessage.getMessage('js.invite.emptyEmail.warn'));
	}else{
		openLoaderBox();
		$.ajax( {
			url : "/inviteUsersSave",
			dataType : "json",
			data : {
			    emails : emails,
			    note: $("#note").val(),
                grecaptcharesponse: grecaptcha.getResponse()
			},
			success : function(data) {
				if(data.hasError){
					$('#invitefail').html(data.errorMessage + "<br>" + data.notValidEmails);
					$('#invitefail').show();
					closeLoaderBox();
					return;
				}else{
					$('#invitefail').hide();	
					
					var resultTable = "<table><tr><td class='invitedHeader' colspan='2'>" + msgInviteFormHeader + "</td></tr>";
					$.each(data.response, function(key, value){
						resultTable = resultTable + "<tr>";
						resultTable = resultTable + "<td>" + data.response[key].email+ "</td>";
						if (data.response[key].status == 0) {
							resultTable = resultTable + "<td><font color='green'>" + msgInviteFormStatus0 + "</font></td>";
						}else if(data.response[key].status == 1) {
							resultTable = resultTable + "<td><font color='red'>" + msgInviteFormStatus1 + "</font></td>";
						}else if(data.response[key].status == 2) {
							resultTable = resultTable + "<td><font color='red'>" + msgInviteFormStatus2 + "</font></td>";
						}
						resultTable = resultTable + "</tr>";
					});
					resultTable = resultTable + "</table>";
					
					$("#inviteResults").html(resultTable);
					$("#emails").val();
				}
				closeLoaderBox();
			}
		});	
	}
	grecaptcha.reset();
};